import { AutomaticGroupBuilderSystem, FunctionalMarginSystem, FunctionalMarginValidation, HostConnectorRotationValidation, OutlineSystem, RequiredConnectorsSatisfiedValidation, StandardSelectionSystem } from '@inter-ikea-core/core';
import { SimpleOutlineSelectedSystem } from '@inter-ikea-core/core-toolbox';
import { CollisionSystem, HandlePlacementValidation, HighlightAddedEntitySystem, HistoryApi, HistoryEventSystem, InvalidFramePlacementSystem, MeasurementsWidgetSystem, ModelLoadedEventSystem, OutlineSelectedFrameSystem, PlannerCoreApi, SelectionEventSystem, UnavailableProductsEventSystem } from '@inter-ikea-storageone/range';
import { KnoxhultProductApi } from './KnoxhultProductApi';
import { KnoxhultEntityApi } from './KnoxhultEntityApi';
import { KnoxhultSceneApi } from './KnoxhultSceneApi';
import { KnoxhultCameraApi } from './KnoxhultCameraApi';
import { AlignWorktopSystem } from './systems/AlignWorktopSystem';
import { AlignWorktopValidation } from './validations/AlignWorktopValidation';
export class KnoxhultCoreApi extends PlannerCoreApi {
    bootstrap(config) {
        if (!this.core) {
            throw new Error('Core not initialized yet');
        }
        // Setup core base functionality
        const { selectionService, placementService } = super.initializeBaseCoreFunctionality();
        // Register core systems
        this.registerSystem(new OutlineSystem());
        this.registerSystem(new AutomaticGroupBuilderSystem(this.core.services.entityManager));
        this.registerSystem(new SimpleOutlineSelectedSystem());
        this.registerSystem(new StandardSelectionSystem(this.core.services.entityManager, this.core.services.sceneManager));
        this.registerSystem(new FunctionalMarginSystem());
        // Register core validations
        this.registerValidation(new RequiredConnectorsSatisfiedValidation());
        this.registerValidation(new HostConnectorRotationValidation());
        this.registerValidation(new FunctionalMarginValidation(false, this.core.services.entityManager));
        // Setup plannner APIs
        this.history = new HistoryApi(this);
        this.products = new KnoxhultProductApi(this.core.services, placementService, this.reportErrorToSentry);
        this.entities = new KnoxhultEntityApi(selectionService, this.core, placementService, this.ipexViewer, this.reportErrorToSentry);
        // Register planner validations
        this.registerValidation(new AlignWorktopValidation(this));
        this.registerValidation(new HandlePlacementValidation(this));
        // Register planner systems
        this.registerSystem(new HistoryEventSystem(this));
        this.registerSystem(new UnavailableProductsEventSystem(this));
        this.registerSystem(new ModelLoadedEventSystem(this));
        this.registerSystem(new InvalidFramePlacementSystem(this));
        this.registerSystem(new CollisionSystem(this, []));
        this.registerSystem(new SelectionEventSystem(this));
        this.registerSystem(new HighlightAddedEntitySystem(this));
        this.registerSystem(new OutlineSelectedFrameSystem(this));
        this.registerSystem(new AlignWorktopSystem(this));
        return this.loadProductCatalogs(config.productCatalogs);
    }
    getMainProductCatalog() {
        return this.catalogs['knoxhult'];
    }
    initSceneApi() {
        this.scene = new KnoxhultSceneApi(this.core, this.ipexViewer, this.reportErrorToSentry);
        this.registerSystem(new MeasurementsWidgetSystem(this));
    }
    initCameraApi(canvas) {
        this.camera = new KnoxhultCameraApi(this.core.services.sceneManager, this.ipexViewer, this.core.services.entityManager, this, canvas);
    }
}
//# sourceMappingURL=KnoxhultCoreApi.js.map